export const CUSTOMER_DISPLAY_LIMIT = 25;

export const CUSTOMER_NEW_ADDRESS_ALLOWED_STORE_IDS = [
  32, 1072, 1146, 21497, 4010,
];
export const CustomerListButtonIconSize = '20px';
export const CustomerListActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};
export const customerTableColumnConfig = {
  id: {
    label: 'ID',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '80px',
        maxWidth: '100px',
      },
      mobile: {
        minWidth: '60px',
        maxWidth: '80px',
      },
    },
  },
  account_number: {
    label: 'Account Number',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '100px',
        maxWidth: '120px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  name: {
    label: 'Name',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '140px',
        maxWidth: '180px',
      },
      mobile: {
        minWidth: '120px',
        maxWidth: '150px',
      },
    },
  },
  register_store_code: {
    label: 'Register Branch',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '100px',
        maxWidth: '120px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  phone_number: {
    label: 'Phone Number',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '120px',
        maxWidth: '150px',
      },
      mobile: {
        minWidth: '120px',
        maxWidth: '150px',
      },
    },
  },
  email: {
    label: 'E‑Mail',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '150px',
        maxWidth: '180px',
      },
      mobile: {
        minWidth: '120px',
        maxWidth: '150px',
      },
    },
  },
  group_price: {
    label: 'Group Price',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '100px',
        maxWidth: '130px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  date_limit: {
    label: 'Date Limit',
    textColumnStyle: 'text-center',
    columnWidth: {
      web: {
        minWidth: '80px',
        maxWidth: '100px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
  receivable_limit: {
    label: 'Receivable Limit',
    textColumnStyle: 'text-end',
    columnWidth: {
      web: {
        minWidth: '90px',
        maxWidth: '100px',
      },
      mobile: {
        minWidth: '90px',
        maxWidth: '100px',
      },
    },
  },
  point_balance: {
    label: 'Points',
    textColumnStyle: 'text-center',
    columnWidth: {
      web: {
        minWidth: '80px',
        maxWidth: '100px',
      },
      mobile: {
        minWidth: '60px',
        maxWidth: '80px',
      },
    },
  },
  comments: {
    label: 'Comments',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '150px',
        maxWidth: '200',
      },
      mobile: {
        minWidth: '100px',
        maxWidth: '150px',
      },
    },
  },
  action: {
    label: 'Action',
    textColumnStyle: 'text-left',
    columnWidth: {
      web: {
        minWidth: '100px',
        maxWidth: '120px',
      },
      mobile: {
        minWidth: '80px',
        maxWidth: '100px',
      },
    },
  },
};

export const getCustomerColumnWidth = (
  isMobile: boolean,
  id: keyof typeof customerTableColumnConfig,
  type: 'minWidth' | 'maxWidth'
): string | undefined => {
  const styleMap = isMobile ? 'mobile' : 'web';

  return customerTableColumnConfig[id].columnWidth[styleMap][type];
};

export const RESPONSE_MESSAGE = {
  UPDATE_SUCCESS: 'Customer updated successfully',
  CREATE_SUCCESS: 'Customer created successfully',
  DELETE_SUCCESS: 'Customer deleted successfully',
};
